export default __webpack_public_path__ + "static/media/Bloodsinger.0e08a0ea.jpg";